import React from "react";
import { ApplicationState } from "../store";
import { DealerPriceState } from "../store/DealerPrice";
import { connect } from "react-redux";
import { MessageBox } from "./MessageBox";

type DealerPriceProps = DealerPriceState & {};

const stateToProps = (state: ApplicationState) => state.dealerPrice;
const dispatcherToProps: DealerPriceProps = {};

const DealerPriceTopMessageBoxComponent: React.FC<DealerPriceProps> = (props: DealerPriceProps) => {
  return (
    // <MessageBox header={props.MessageTopTitle}>
    <MessageBox>{props.MessageTop}</MessageBox>
  );
};
export const DealerPriceTopMessage = connect(stateToProps, dispatcherToProps)(DealerPriceTopMessageBoxComponent);

const DealerPriceBottomMessageBoxComponent: React.FC<DealerPriceProps> = (props: DealerPriceProps) => {
  return <MessageBox>{props.MessageBottom}</MessageBox>;
};
export const DealerPriceBottomMessage = connect(stateToProps, dispatcherToProps)(DealerPriceBottomMessageBoxComponent);
